import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { responsiveSizing } from '@vfuk/core-mixins'

import type { StyledSimpleBadgeProps } from './SimpleBadge.style.types'

export const SimpleBadge = styled.div((props: StyledSimpleBadgeProps): FlattenSimpleInterpolation => {
  const { color } = props.simpleBadgeTheme.appearance[props.appearance]
  return css`
    ${responsiveSizing('width', 2)};
    ${responsiveSizing('height', 2)};
    border-radius: 50%;
    background-color: ${props.state ? props.theme.color[props.state].default : color};
  `
})
